export interface ILoginOutputDto {
    accessToken: string;
    refreshToken: string;
}
